export const commonActions = {
    MESSAGE_TEXT: "MESSAGE_TEXT",
    LABEL: "LABEL",
    SEEDING_DATA: "SEEDING_DATA",
    BADGE_DATA: "BADGE_DATA",
    COLUMN_DATA: "COLUMN_DATA",
    COLUMN_LOCK_TOGGLE: "COLUMN_LOCK_TOGGLE",
    SAVED_COLUMN_DATA: "SAVED_COLUMN_DATA",
    SAVED_FILTER_DATA: "SAVED_FILTER_DATA",
    PER_PAGE: "PER_PAGE",
};
